/**
 * Kebab-cased permission names from before the camelCase rename. Remove this module and the
 * `holdsPermission` / `expandPermissionsWithLegacyAliases` call sites once frontend and backend
 * no longer ship mixed deploys.
 */
export const legacyPermissionAliases = {
  'invoice.mark-as-paid': 'invoice.markAsPaid',
  'invoice.mark-as-paid.managedByOrusOnly': 'invoice.markAsPaid.managedByOrusOnly',
  'invoice.regenerate-documents': 'invoice.regenerateDocuments',
  'invoice.sync-payments': 'invoice.syncPayments',
  'notifications-configuration.read': 'notificationsConfiguration.read',
  'notifications-configuration.write': 'notificationsConfiguration.write',
  'organization-advanced.edit': 'organizationAdvanced.edit',
  'subscription-application-status.write': 'subscriptionApplicationStatus.write',
  'subscription-application-status.read': 'subscriptionApplicationStatus.read',
  'subscription-application-status.cancel-approved': 'subscriptionApplicationStatus.cancelApproved',
  'subscription-application-status.cancel-rejected': 'subscriptionApplicationStatus.cancelRejected',
  'subscription-application-status.take-over': 'subscriptionApplicationStatus.takeOver',
  'subscription-application-status.send-to-inspector': 'subscriptionApplicationStatus.sendToInspector',
  'subscription-application-status.send-to-underwriter': 'subscriptionApplicationStatus.sendToUnderwriter',
  'subscription-application-status.approve': 'subscriptionApplicationStatus.approve',
  'subscription-application-status.reject': 'subscriptionApplicationStatus.reject',
  'subscription-application-status.incomplete': 'subscriptionApplicationStatus.incomplete',
  'subscription-application-status.start-application': 'subscriptionApplicationStatus.startApplication',
  'subscription-application-status.start-validation': 'subscriptionApplicationStatus.startValidation',
  'subscription-application-status.cancel': 'subscriptionApplicationStatus.cancel',
  'subscription-file-group-status.write': 'subscriptionFileGroupStatus.write',
  'subscription-file-group-status.read': 'subscriptionFileGroupStatus.read',
  'subscription-file-group-status.edit-approved': 'subscriptionFileGroupStatus.editApproved',
  'subscription-file-group-status.edit-rejected': 'subscriptionFileGroupStatus.editRejected',
  'subscription-file-group-status.approve': 'subscriptionFileGroupStatus.approve',
  'subscription-file-group-status.reject': 'subscriptionFileGroupStatus.reject',
  'subscription-file-group-status.incomplete': 'subscriptionFileGroupStatus.incomplete',
  'subscription-file-group-status.send-to-inspector': 'subscriptionFileGroupStatus.sendToInspector',
  'subscription-file-group-status.send-to-underwriter': 'subscriptionFileGroupStatus.sendToUnderwriter',
  'subscription-collected-file-status.write': 'subscriptionCollectedFileStatus.write',
  'subscription-collected-file-status.read': 'subscriptionCollectedFileStatus.read',
  'subscription-collected-file-status.edit-approved': 'subscriptionCollectedFileStatus.editApproved',
  'subscription-collected-file-status.edit-rejected': 'subscriptionCollectedFileStatus.editRejected',
  'subscription-collected-file-status.approve': 'subscriptionCollectedFileStatus.approve',
  'subscription-collected-file-status.reject': 'subscriptionCollectedFileStatus.reject',
  'subscription-collected-file-status.incomplete': 'subscriptionCollectedFileStatus.incomplete',
  'subscription-collected-file-status.send-to-inspector': 'subscriptionCollectedFileStatus.sendToInspector',
  'subscription-collected-file-status.send-to-underwriter': 'subscriptionCollectedFileStatus.sendToUnderwriter',
  'debug-history.read': 'debugHistory.read',
  'account-manager.read': 'accountManager.read',
  'excluded-subscription.manage': 'excludedSubscription.manage',
  'subscription.share-with-broker-manager-team': 'subscription.shareWithBrokerManagerTeam',
} as const

export type LegacyPermission = keyof typeof legacyPermissionAliases
